import { CTA, styled, Text, TokenTextAppearance, TokenTextColor, TextTag } from "@volkswagen-onehub/components-core";
import { Close } from "@volkswagen-onehub/icons-core";
import React from "react";
import { getTranslations } from "../translations";
import { LayerCloseHandle } from "../types/layers";

const DisclaimerContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-flow: row-reverse;
  column-gap: 16px;
  position: relative;
  width: 100%;
  max-height: 25vh;
`;

const DisclaimersWrapper = styled.div`
  pointer-events: all;
  flex: 0 1 auto;
  width: 100%;
  max-height: calc(25vh - 32px);
  overflow-y: -moz-scrollbars-vertical;
  overflow-y: scroll;
  overflow-y: auto;
`;

const CloseWrapper = styled.div`
  flex: 0 0 auto;
`;

const StyledDl = styled.dl`
  display: grid;
  grid-template-columns: ${props => props.theme.size.dynamic0100} auto;
  gap: 12px 8px;
  margin: 0;
  padding: 0 8px 0 0;
`;

const StyledDt = styled.dt`
  margin: 0;
  padding: 0;
`;

const StyledDd = styled.dd`
  margin: 0;
  padding: 0;
`;

interface Props {
  marker: string | number;
  text: string;
  close: LayerCloseHandle;
};

export const DisclaimerModal = ({ marker, text, close }: Props) => {
  const { aria } = getTranslations();

  const handleClick = () => {
    close();
  };

  return (
    <DisclaimerContainer>
      <CloseWrapper>
        <CTA
          tag="button"
          emphasis="none"
          onClick={handleClick}
          ariaLabel={aria.close}
          icon={<Close variant="default" ariaHidden />}
        />
      </CloseWrapper>
      <DisclaimersWrapper>
        <Text
          tag={TextTag.div}
          appearance={TokenTextAppearance.copy100}
          color={TokenTextColor.primary}
          staticSize
          wordBreak
        >
          <StyledDl>
            <StyledDt>
              { marker.toString() }
            </StyledDt>
            <StyledDd>
              { text }
            </StyledDd>
          </StyledDl>
        </Text>
      </DisclaimersWrapper>
    </DisclaimerContainer>
  );
};
